import { Col, Row } from "antd";
import { TextComponent } from "../../../../../components";
import styles from "./SingleBudget.module.css";
import { useLocation } from "react-router-dom";
import { priceFormat } from "../../../../../Store/Actions/GeneralActions";

const WalletIcon = () => {
  return (
    <svg
      //   width="132"
      //   height="173"
      className={styles.icon}
      viewBox="0 0 132 173"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_58_14672)">
        <path
          d="M85.1001 131.186C85.1001 141.65 85.1405 152.114 85.0798 162.578C85.0596 166.326 85.0798 171.026 80.9444 171.988C77.8605 172.708 73.4621 171.593 70.813 169.689C51.8344 155.973 32.9569 142.106 14.4636 127.742C5.55566 120.824 0.853981 110.998 0.732647 99.572C0.510202 78.9786 0.500091 58.3852 0.84387 37.802C0.894425 34.4997 2.38076 30.1643 4.76699 28.2194C8.07334 25.5148 12.0875 28.0269 15.3028 30.4276C33.6748 44.1127 52.1782 57.6357 70.3681 71.5739C79.8119 78.8064 84.8372 88.7841 85.0798 100.818C85.2618 110.927 85.1001 121.057 85.1001 131.186Z"
          className={styles.iconPath}
        />
        <path
          d="M103.099 51.5476C93.1803 37.3763 84.1308 24.4611 74.7578 11.0698C65.9206 17.2489 57.2756 23.2861 48.6306 29.3436C38.024 36.7685 38.024 36.7685 27.8016 28.6142C27.3365 28.2496 26.9219 27.814 26.4062 27.348C26.9826 26.9834 27.2657 26.6592 27.478 26.6896C36.6084 28.3306 43.484 23.8635 50.3494 18.6974C58.8024 12.3664 67.6193 6.52166 76.6384 0.210938C81.9266 7.72707 87.2754 14.8482 92.0478 22.344C94.2723 25.8489 96.8304 26.8314 100.703 26.6896C107.427 26.4262 114.171 26.5782 120.905 26.6288C128.266 26.6896 131.512 29.7893 131.532 37.0015C131.582 64.6654 131.582 92.3292 131.532 119.993C131.522 127.246 128.61 130.224 121.532 130.295C112.634 130.386 103.726 130.315 94.4138 130.315C92.7758 110.502 98.5291 89.7259 83.0792 71.756C90.3795 71.756 96.3248 71.756 102.28 71.756C104.131 71.756 105.991 71.8067 107.831 71.7155C110.885 71.5535 113.17 70.2771 113.079 66.8736C112.988 63.5511 110.804 62.214 107.67 62.214C99.5907 62.2039 91.4007 61.4036 83.4533 62.4065C73.2411 63.6929 66.7598 58.2331 59.2473 51.5577C74.0196 51.5476 87.8618 51.5476 103.099 51.5476Z"
          className={styles.iconPath}
        />
      </g>
      <defs>
        <clipPath id="clip0_58_14672">
          <rect
            width="131"
            height="172"
            fill="white"
            transform="translate(0.5625 0.210938)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

const budgetStats = [
  { title: "Left to Spend", value: "10,750" },
  { title: "Budget Used", value: "14,250" },
];

const SingleBudget = () => {
  const { state } = useLocation();

  // console.log("state.item", state.data);

  const item = state?.data?.item;
  return (
    <Row className={styles.budgetContainer}>
      <Col xs={24} md={15} lg={14} className={styles.leftCol}>
        <Row className={styles.verticalRow}>
          <TextComponent textClass={styles.singleItemTitle}>
            {state?.data?.eventData?.name}
          </TextComponent>
          <TextComponent textClass={styles.singleItemCategory}>
            {item?.title}
          </TextComponent>
        </Row>
        <Row className={styles.verticalRow}>
          <TextComponent textClass={styles.budgetHeading}>Budget</TextComponent>
          <TextComponent textClass={styles.singleItemBudget}>
            ${priceFormat(item?.total_budget)}
          </TextComponent>
        </Row>
        <Row className={styles.singleItemStats}>
          <Col xs={24} sm={12} md={16} lg={12}>
            <TextComponent textClass={styles.singleItemSubTitle}>
              Actual Cost
            </TextComponent>
          </Col>
          <Col xs={24} sm={12} md={8} lg={12}>
            <TextComponent textClass={styles.singleItemPricePrimary}>
              ${item?.actual_cost > 0 ? priceFormat(item?.actual_cost) : 0}
            </TextComponent>
          </Col>
          <Col xs={24} sm={12} md={16} lg={12}>
            <TextComponent textClass={styles.singleItemSubTitle}>
              Payment
            </TextComponent>
          </Col>
          <Col xs={24} sm={12} md={8} lg={12}>
            <TextComponent textClass={styles.singleItemPrice}>
              $
              {item?.paid < 0
                ? priceFormat(item?.paid).replace("-", "")
                : item?.paid > 0
                ? priceFormat(item?.paid)
                : "0"}
            </TextComponent>
          </Col>
          <Col xs={24} sm={12} md={16} lg={12}>
            <TextComponent textClass={styles.singleItemSubTitle}>
              Open Balance
            </TextComponent>
          </Col>
          <Col xs={24} sm={12} md={8} lg={12}>
            <TextComponent textClass={styles.singleItemPrice}>
              ${item?.unpaid > 0 ? priceFormat(item?.unpaid) : "0"}
            </TextComponent>
          </Col>
        </Row>
      </Col>
      <Col md={8} lg={7} xl={6} className={styles.iconCol}>
        <WalletIcon />
      </Col>
    </Row>
  );
};

export default SingleBudget;
